export default __webpack_public_path__ + "static/media/rectangle.d8ea8f58.svg";